export default {
  items: [],
  info: {
    id: 0,
    type: null,
    key: null,
    val: null
  }
}
